import email from "../assets/email.png";
import mobile from "../assets/mobile.png";
import api from "../assets/api.png";
import cpp from "../assets/cpp.png";
import css from "../assets/css.png";
import figma from "../assets/figma.png";
import flutter from "../assets/flutter.png";
import git from "../assets/git.png";
import graphql from "../assets/graphql.png";
import html from "../assets/html.png";
import javascript from "../assets/javascript.png";
import mu5 from "../assets/mu5.png";
import node from "../assets/node.png";
import python from "../assets/python.png";
import react from "../assets/react.png";
import redux from "../assets/redux.png";
import sass from "../assets/sass.png";
import typescript from "../assets/typescript.png";
import vue from "../assets/vue.png";
import mysql from "../assets/MySQL.png";

import about01 from "../assets/about01.png";
import about02 from "../assets/about02.png";
import about03 from "../assets/about03.png";
import about04 from "../assets/about04.png";

import profile from "../assets/p.png";
import circle from "../assets/circle.svg";
import logo from "../assets/logo.png";

import nb from "../assets/nb.png";
import skype from "../assets/skype.png";
import spotify from "../assets/spotify.png";

import tenzi from "../assets/tenzi.png";
import yourtube from "../assets/yourtube.png";
import leetcode from "../assets/leetcode.png";
import hackerrank from "../assets/hackerrank.png";
import codingninjas from "../assets/codingninjas.png";
import shoppingcart from "../assets/shoppingcart.png";
import chatai from "../assets/chatai.png";
import admindashboard from "../assets/admindashboard.png";
import noteapp from "../assets/noteapp.png";

import resume from "../assets/resume.png";
import linkedin from "../assets/linkedin.png";
import twitter from "../assets/twitter.png";
import github from "../assets/github.png";
import oop from "../assets/oop.png";
import springboot from "../assets/springboot.png";

const images = {
  email,
  mobile,
  api,
  cpp,
  css,
  figma,
  flutter,
  git,
  graphql,
  html,
  javascript,
  mu5,
  node,
  python,
  react,
  redux,
  sass,
  typescript,
  vue,
  mysql,
  about01,
  about02,
  about03,
  about04,
  profile,
  circle,
  logo,
  nb,
  skype,
  spotify,
  tenzi,
  yourtube,
  shoppingcart,
  chatai,
  admindashboard,
  noteapp,
  leetcode,
  hackerrank,
  codingninjas,
  resume,
  linkedin,
  twitter,
  github,
  oop,
  springboot,
};

export default images;
